import { merge } from 'views/utils'
import { toActionName } from '../utils'

const modules = Object
  .fromEntries(require
    .context('.', true, /js$/)
    .keys()
    .filter(path => !path.includes('index'))
    .map(path => path.slice(2, -3))
    .map((moduleName) => [moduleName, require(`./${moduleName}`).default]))

export default Object.entries(modules).map(([moduleKey, storeModule]) => {
  if (!storeModule.auto) storeModule.auto = []

  const auto = new Set(storeModule.auto === '*'
    ? ['actions', 'getters', 'mutations', 'sync']
    : storeModule.auto)

  return Object.assign(
    merge({
      // external service name without apiBase (someService)
      serviceName: auto.has('actions')
        ? moduleKey
        : null,

      hasJoins: (storeModule.joins && Object.keys(storeModule.joins).length) || false,
      hasJoinsFixed: false,
      joins: storeModule.joins || {},

      isClearable: auto.has('mutations') && storeModule.isClearable !== false,
      isFrozen: false,

      cacheFor: 5000,

      // suffix for store actions (SOME_SERVICE)
      tableName: moduleKey,
      storeSuffix: toActionName(moduleKey),
      // internal store key (someService) used for queries
      storeKey: moduleKey,

      store: {
        state: {
          list: {},
          pages: {},
        },
      },
    }, storeModule),
    { auto })
})
